module.exports = __webpack_public_path__ + "static/media/SketchPng4420ce05fbeb75905a3c3c0691d5031b4627da5c16d38d4503a7de6d9fb91413.244cd1de.png";